import { API } from 'api'
import { SupportPayload } from 'utils/validations'

export const sendSupportLetterAPI = (
  payload: Omit<SupportPayload, 'topic'> & { topic: string }
) => {
  return API.post('/support', payload).then((res) => res.data)
}
